import { postApiGalaxyServer } from 'services';

export interface CreateServicePayload {
  name: string;
  serviceName: string;
  cloudIntegrationName?: string;
  onPremIntegrationName?: string;
  /** Required — rendered as the label in the Service Name dropdowns. */
  serviceDisplayName: string;
  onPremIntegrationDisplayName?: string;
  isIntegrationAgent?: boolean;
  canBeSeeded?: boolean;
  mustBeSeeded?: boolean;
  seedBucket?: string;
  sourceSeedBucket?: string;
  requiredForSubscription?: boolean;
  requiredForSandbox?: boolean;
}

/**
 * POST /service
 * Creates a new service entry in the service table.
 */
export const createServiceApi = ({
  params,
  token,
  config = {},
}: BaseApiParams<CreateServicePayload>) => {
  return postApiGalaxyServer<CreateServicePayload, unknown>(`/service`, params, config, token);
};
